// ============================================================================
// AntdProvider — Choice MCN Platform
// File: src/theme/AntdProvider.jsx
//
// Wraps the app in ConfigProvider so every antd component picks up the
// brand theme. Also enables the React 19 patch so antd's static
// Modal/Notification/Message methods work outside React's tree.
// ============================================================================
import React from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import enUS from 'antd/locale/en_US';
import '@ant-design/v5-patch-for-react-19';
import antdTheme from './antdTheme';

const AntdProvider = ({ children }) => (
  <ConfigProvider theme={antdTheme} locale={enUS}>
    <AntdApp>{children}</AntdApp>
  </ConfigProvider>
);

export default AntdProvider;
